// extracted by mini-css-extract-plugin
module.exports = {"color-primary":"#005a7c","color-secondary":"#f2b825","color-white":"#fff","color-success":"#76a973","color-danger":"#c53762"};